import { IconDefinition, faPause, faPlay, faVolume, faVolumeOff } from '@fortawesome/pro-solid-svg-icons';

import { ActionType } from './types';

export function getNextAction(currentAction: ActionType): ActionType {
  return currentAction === ActionType.PAUSE ? ActionType.PLAY : ActionType.PAUSE;
}

export const ANIMATION_ACTION_ICONS: Record<ActionType, IconDefinition> = {
  Play: faPlay,
  Pause: faPause,
};

export const MUSIC_ACTION_ICONS: Record<ActionType, IconDefinition> = {
  Play: faVolume,
  Pause: faVolumeOff,
};
